import { hasActiveSprintsSelector } from '../../state/selectors/sprint/sprint-selectors.tsx';
import type { State } from '../../state/types.tsx';

export const shouldDisableStandup = ({
	boardType,
	isSprintsEnabled,
	hasActiveSprint,
}: {
	boardType: string | undefined;
	isSprintsEnabled: boolean;
	hasActiveSprint: boolean;
}) => {
	if (boardType === 'Kanban') {
		return false;
	}

	return isSprintsEnabled && !hasActiveSprint;
};

export function getIsCompleteSprintButtonVisible(state: State): boolean {
	// allow the render of a disabled button if no permissions to manage the sprint
	return hasActiveSprintsSelector(state);
}
